import { render, staticRenderFns } from "./ctx-menu.vue?vue&type=template&id=7235c1bf&scoped=true&"
import script from "./ctx-menu.vue?vue&type=script&lang=js&"
export * from "./ctx-menu.vue?vue&type=script&lang=js&"
import style0 from "./ctx-menu.vue?vue&type=style&index=0&id=7235c1bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235c1bf",
  null
  
)

export default component.exports